// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3718":"a53169e5","4195":"82c855fa","6483":"ff5746bd","8564":"4c7d7ec2","9258":"b256cdec","9393":"63bea536","9991":"37681748"}[chunkId] + ".chunk.css";
};